import { Component, OnInit } from '@angular/core';
import { FormGroupExt } from '../../../../form-ext/form-group.ext';
import { AbstractControl, Validators } from '@angular/forms';
import { FormBuilderExt } from '../../../../form-ext/form-builder.ext';
import { AuthService } from '../../services/auth.service';
import { ConfigService } from '../../../../services/config/config.service';
import { HttpClient } from '@angular/common/http';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { ToastService } from '../../../../../common-modules/services/toast.service';
import { CompaniesService } from '../../../companies/services/companies.service';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    standalone: false,
})
export class SignupComponent implements OnInit {
    public formGroup: FormGroupExt;
    public companyPlaceholder = $localize`Company Name`;
    public LicenseKeyPlaceholder = $localize`License Key`;
    public emailPlaceholder = $localize`Email`;
    public phonePlaceholder = $localize`Phone`;
    public firstNamePlaceholder = $localize`First Name`;
    public lastNamePlaceholder = $localize`Last Name`;
    protected readonly environment = environment;

    constructor(
        public formBuilder: FormBuilderExt,
        public authService: AuthService,
        public companiesService: CompaniesService,
        public configService: ConfigService,
        protected readonly http: HttpClient,
        // protected recaptchaV3Service: ReCaptchaV3Service,
        private router: Router,
        private toastService: ToastService,
    ) {}

    public get CompanyNameControl(): AbstractControl | null {
        return this.formGroup?.group.get('companyName');
    }

    public get LicenseKeyControl(): AbstractControl | null {
        return this.formGroup?.group.get('licenseKey');
    }

    public get EmailControl(): AbstractControl | null {
        return this.formGroup?.group.get('email');
    }

    public get PhoneControl(): AbstractControl | null {
        return this.formGroup?.group.get('phone');
    }

    public get FirstNameControl(): AbstractControl | null {
        return this.formGroup?.group.get('firstName');
    }

    public get LastNameControl(): AbstractControl | null {
        return this.formGroup?.group.get('lastName');
    }

    public get GenderControl(): AbstractControl | null {
        return this.formGroup?.group.get('gender');
    }

    public get TermsControl(): AbstractControl | null {
        return this.formGroup?.group.get('agreeWithTermsAndCo');
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.groupExt(
            {
                companyName: ['', [Validators.required]],
                licenseKey: ['', Validators.required],
                email: ['', Validators.required],
                phone: ['', Validators.required],
                firstName: ['', Validators.required],
                lastName: ['', Validators.required],
                gender: ['mrs', Validators.required],
                tc_accepted: ['', Validators.required],
            },
            {},
            {
                companyName: {
                    required: $localize`Company name is required`,
                },
            },
        );
    }

    public async signUp() {
        const formData = new FormData();
        formData.append('name', this.CompanyNameControl?.value);
        formData.append('first_name', this.FirstNameControl?.value);
        formData.append('last_name', this.LastNameControl?.value);
        formData.append('email', this.EmailControl?.value);
        formData.append('license_key', this.LicenseKeyControl?.value);
        formData.append('phone', this.PhoneControl?.value);
        formData.append('is_msp', 'true');

        this.companiesService.createSingle(formData, 'cz/register').subscribe(
            (res) => {
                this.toastService.showSuccess('You will be redirected to the login page.', { duration: 3000 });
                this.router.navigate(['/']);
            },
            (error) => {
                this.toastService.showError('There was an error during your sign up process.', { duration: 3000 });
            },
        );
        // this.recaptchaV3Service.execute('importantAction').subscribe((token: string) => {
        //     console.debug(`Token [${token}] generated`);
        // });
    }

    resolved(captchaResponse: string) {
        console.log(`Resolved captcha with response: ${captchaResponse}`);
    }

    errored(event: any) {
        console.warn(`reCAPTCHA error encountered`);
    }
}
